<script>
  import {textAreaProps, initValue} from '../index'

  export default {
    props: textAreaProps,
    render () {
      const value = initValue(this.value)
      return <read-text {...this.$props} computeHeight={true} value={value}></read-text>
    }
  }
</script>
